import { render } from "./NoahMasters.vue?vue&type=template&id=4bb35de2&scoped=true"
import script from "./NoahMasters.vue?vue&type=script&lang=js"
export * from "./NoahMasters.vue?vue&type=script&lang=js"

import "./NoahMasters.vue?vue&type=style&index=0&id=4bb35de2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bb35de2"]])

export default __exports__